import TransDeliveryReceipt from "../TransDeliveryReceipt";

const TransDeliveryReceiptWithSO = () => <TransDeliveryReceipt withSalesOrder />;

export default TransDeliveryReceiptWithSO;
